import { api_postValueOrErrorMessage } from "./util";

export function api_logErrorPayment(data: any){
  api_postValueOrErrorMessage("support/crashes/add", {
    message: "payment_failed",
    stacktrace: "",
    context: JSON.stringify(data)
  });
}